var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFondeeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.814 1.746C14.394 3.266 9.612 6.272 6.6 8.084c-1.703 1.023-4.56-.213-5.342-2.386-.78-2.172.91-4.897 2.841-4.897h11.858c1.17 0 1.76 1.224 1.44 1.921-.098.21-3.44 7.122-4.955 10.285-.864 1.792-3.927 2.334-5.776.948-1.85-1.386-1.93-4.58-.317-5.644 2.42-1.596 7.94-5.024 10.547-6.626",
    stroke: "#000",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgFondeeIcon;